import { PlusOutlined, ProfileOutlined, BookOutlined, UserOutlined, BankOutlined, FileTextOutlined, DollarOutlined, CalendarOutlined, GlobalOutlined, TagOutlined, DeleteOutlined, DownloadOutlined, FileExcelOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Input, InputNumber, Row, Select, notification, Card, Upload, Table } from "antd";
import TextArea from "antd/lib/input/TextArea";
import Modal from "antd/lib/modal/Modal";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import * as XLSX from 'xlsx';

import {
    addAuthorRequest, addCategoryRequest, addPublisherRequest, addTranslatorRequest, getAuthorRequest, getCategoryRequest, getPublisherRequest, getBookRequest
} from "../../redux/controller";
import { useDispatchRoot, useSelectorRoot } from "../../redux/store";
import "./uploadBook.styles.scss";
import axios from "axios";
import { API_URL } from "../../enums/api.enums";
import { confirmCloseModal } from '../../components/modalEditBook/CModalConfirmClose';
import TagsSelector from '../../components/TagsSelector/TagsSelector';
import BookApi from '../../api/book/book.api';
import { tagsApi } from '../../api/tags/tags.api';



const UploadBook = () => {

    // Removed unused Option variable
    const { listCategory, listAuthor, listPublisher } =
        useSelectorRoot((state) => state.management);
    const navigate = useNavigate();


    // Remove unused single book states since we're now using bookRows

    const [openModalCategory, setOpenModalCategory] = useState<boolean>(false)
    const [openModalPublisher, setOpenModalPublisher] = useState<boolean>(false)
    const dispatch = useDispatchRoot();

    const [newCategory, setNewCategory] = useState(null)
    const [newPublisher, setNewPublisher] = useState(null)

    const [isModalCriteriaOpen, setIsModalCriteriaOpen] = useState(false); // Biến kiểm tra modal thêm mới thể loại
    const [isModalAuthorOpen, setIsModalAuthorOpen] = useState(false); // Biến kiểm tra modal thêm mới tác giả
    const [isModalTranslatorOpen, setIsModalTranslatorOpen] = useState(false); // Biến kiểm tra modal thêm mới dịch giả
    const [isModalPublisherOpen, setIsModalPublisherOpen] = useState(false); // Biến kiểm tra modal thêm mới nhà xuất bản
    const [formAddCriteria] = Form.useForm(); // Biến form thêm mới thể loại
    const [formAddAuthor] = Form.useForm(); // Biến form thêm mới tác giả 
    const [formAddTranslator] = Form.useForm(); // Biến form thêm mới dịch giả
    const [formAddPublisher] = Form.useForm(); // Biến form thêm mới nhà xuất bản

    // State để theo dõi thay đổi trong các form modal
    const [hasChangesCriteria, setHasChangesCriteria] = useState(false);
    const [hasChangesAuthor, setHasChangesAuthor] = useState(false);
    const [hasChangesTranslator, setHasChangesTranslator] = useState(false);
    const [hasChangesPublisher, setHasChangesPublisher] = useState(false);
    const [lstTranslator, setLstTranslator] = useState<any>([])
    const [lstTags, setLstTags] = useState<any>([])
    const [isSubmitting, setIsSubmitting] = useState(false) // Prevent double submission

    // Excel upload states
    const [isExcelModalVisible, setIsExcelModalVisible] = useState(false);
    const [excelData, setExcelData] = useState<any[]>([]);
    const [excelFile, setExcelFile] = useState<any>(null);
    const [isProcessingExcel, setIsProcessingExcel] = useState(false);

    // Multiple books states
    const [bookRows, setBookRows] = useState<any[]>([{
        id: 1,
        name: '',
        description: '',
        pageNumber: 0,
        pricePaper: 0,
        priceEbook: 0,
        priceAudio: 0,
        amount: 50,
        ISBN: '',
        size: '',
        releaseDate: new Date().toISOString().split('T')[0],
        language: 'vietnamese',
        thumbnailUrl: '',
        categoryIds: [],
        authorIds: [],
        translatorIds: [],
        publishing_house_id: null,
        tagIds: []
    }]) // Array of book rows

    useEffect(() => {
        dispatch(getCategoryRequest());
        dispatch(getAuthorRequest());
        dispatch(getPublisherRequest());
        getAllTranslator()
        getAllTags()
    }, [dispatch]);

    // Theo dõi thay đổi trong form thêm thể loại
    useEffect(() => {
        const checkChanges = () => {
            const values = formAddCriteria.getFieldsValue();
            const hasChanges = values.criteria && values.criteria.trim() !== '';
            setHasChangesCriteria(hasChanges);
        };

        // Kiểm tra khi modal mở
        if (isModalCriteriaOpen) {
            checkChanges();
        }
    }, [isModalCriteriaOpen, formAddCriteria]);

    // Theo dõi thay đổi trong form thêm tác giả
    useEffect(() => {
        const checkChanges = () => {
            const values = formAddAuthor.getFieldsValue();
            const hasChanges = values.name && values.name.trim() !== '';
            setHasChangesAuthor(hasChanges);
        };

        // Kiểm tra khi modal mở
        if (isModalAuthorOpen) {
            checkChanges();
        }
    }, [isModalAuthorOpen, formAddAuthor]);

    // Theo dõi thay đổi trong form thêm nhà xuất bản
    useEffect(() => {
        const checkChanges = () => {
            const values = formAddPublisher.getFieldsValue();
            const hasChanges = values.publisher && values.publisher.trim() !== '';
            setHasChangesPublisher(hasChanges);
        };

        // Kiểm tra khi modal mở
        if (isModalPublisherOpen) {
            checkChanges();
        }
    }, [isModalPublisherOpen, formAddPublisher]);

    // Theo dõi thay đổi trong form thêm dịch giả
    useEffect(() => {
        const checkChanges = () => {
            const values = formAddTranslator.getFieldsValue();
            const hasChanges = values.name && values.name.trim() !== '';
            setHasChangesTranslator(hasChanges);
        };

        // Kiểm tra khi modal mở
        if (isModalTranslatorOpen) {
            checkChanges();
        }
    }, [isModalTranslatorOpen, formAddTranslator]);



    // Removed unused single book functions

    const onAddCategory = () => {
        const bodyRequest = {
            name: newCategory
        }
        dispatch(addCategoryRequest(bodyRequest))
        setOpenModalCategory(false)
        setNewCategory(null)
    }

    const onCancelAddCategory = () => {
        setOpenModalCategory(false)
        setNewCategory(null)
    }



    const onAddPublisher = () => {
        const bodyRequest = {
            name: newPublisher
        }
        dispatch(addPublisherRequest(bodyRequest))
        setOpenModalPublisher(false)
        setNewPublisher(null)
    }

    const onCancelAddPublisher = () => {
        setOpenModalPublisher(false)
        setNewPublisher(null)
    }

    const handleCategoryChange = (event: { target: { value: any } }) => {
        setNewCategory(event.target.value);
    };



    const handlePublisherChange = (event: { target: { value: any } }) => {
        setNewPublisher(event.target.value);
    };

    const getAuthorName = (record: any) => {
        // Ưu tiên sử dụng trường name mới
        if (record.name) {
            return record.name;
        }

        // Fallback về format cũ để tương thích ngược
        let authorName = ""
        if (record.firstName) {
            authorName += record.firstName
        }
        if (record.middleName) {
            authorName += " " + record.middleName
        }
        if (record.lastName) {
            authorName += " " + record.lastName
        }
        return authorName || "Không có tên";
    }

    const handleAddCriteria = async (value: any) => {
        console.log(value)

        const req = {
            name: value.criteria,
            description: ""
        }

        await axios.post(`${API_URL.HOST}/category`, req)
            .then(res => {
                console.log(res)
                dispatch(getCategoryRequest())
                setIsModalCriteriaOpen(false)
                formAddCriteria.resetFields();
                setHasChangesCriteria(false);

                notification.success({
                    message: "Thêm thể loại thành công",
                    placement: "bottomRight"
                })

            })
            .catch(err => {
                console.log(err)
            })
    }

    const handleAddAuthor = async (value: any) => {
        console.log(value)

        const bodyRequest = {
            name: value.name,
            description: value.description,
            birthYear: value.birthYear ? parseInt(value.birthYear) : undefined,
        }

        dispatch(addAuthorRequest(bodyRequest));
        setIsModalAuthorOpen(false)
        formAddAuthor.resetFields();
        setHasChangesAuthor(false);


    }

    const handleAddTranslator = async (value: any) => {
        console.log(value)

        const bodyRequest = {
            name: value.name,
            description: value.description,
            birthYear: value.birthYear ? parseInt(value.birthYear) : undefined,
        }

        dispatch(addTranslatorRequest(bodyRequest));
        setIsModalTranslatorOpen(false)
        formAddTranslator.resetFields();
        setHasChangesTranslator(false);

        notification.success({
            message: "Thêm dịch giả thành công",
            placement: "bottomRight"
        })
    }

    const handleAddPublisher = async (value: any) => {
        console.log(value)

        const req = {
            name: value.publisher,
            description: "",
        }

        let token: any = localStorage.getItem("token");
        // Lấy ra token trong localStorage
        token = token.replace(/['"]+/g, '');
        console.log("token", token);
        await fetch(`${API_URL.HOST}/publishing-houses`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,

            },
            body: JSON.stringify(req),
        }).then(res => res.json())
            .then(data => {
                console.log('Success:', data);
                dispatch(getPublisherRequest())
                setIsModalPublisherOpen(false)
                formAddPublisher.resetFields();
                setHasChangesPublisher(false);

                notification.success({
                    message: "Thêm nhà xuất bản thành công",
                    placement: "bottomRight"
                })
            })
            .catch((error) => {
                console.error('Error:', error);
            })
    }

    const getAllTranslator = async () => {
        await axios.get(`${API_URL.HOST}/translator`)
            .then(res => {
                console.log(res.data.data)
                if (res.data.data.length > 0) {
                    setLstTranslator(res.data.data)
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    const getAllTags = async () => {
        try {
            const tags = await tagsApi.getActiveTags();
            console.log('Tags:', tags);
            setLstTags(tags);
        } catch (error) {
            console.error('Error fetching tags:', error);
            setLstTags([]);
        }
    }

    // ===== AUTO-CREATE ENTITIES FROM EXCEL =====
    const getToken = () => {
        let token: any = localStorage.getItem("token");
        return token ? token.replace(/['"]+/g, '') : '';
    };

    const ensureEntitiesExist = async (data: any[]) => {
        // Collect all unique names from Excel
        const uniqueAuthors = new Set<string>();
        const uniqueCategories = new Set<string>();
        const uniquePublishers = new Set<string>();
        const uniqueTranslators = new Set<string>();
        const uniqueTags = new Set<string>();

        data.forEach((row: any) => {
            const authorStr = row['Tên tác giả (phân cách bằng dấu phẩy)'];
            if (authorStr) {
                authorStr.toString().split(',').forEach((n: string) => {
                    const trimmed = n.trim();
                    if (trimmed) uniqueAuthors.add(trimmed);
                });
            }
            const catStr = row['Tên thể loại (phân cách bằng dấu phẩy)'];
            if (catStr) {
                catStr.toString().split(',').forEach((n: string) => {
                    const trimmed = n.trim();
                    if (trimmed) uniqueCategories.add(trimmed);
                });
            }
            const pubStr = row['Tên nhà xuất bản'];
            if (pubStr && pubStr.trim()) {
                uniquePublishers.add(pubStr.trim());
            }
            const transStr = row['Tên dịch giả (phân cách bằng dấu phẩy)'];
            if (transStr) {
                transStr.toString().split(',').forEach((n: string) => {
                    const trimmed = n.trim();
                    if (trimmed) uniqueTranslators.add(trimmed);
                });
            }
            const tagStr = row['Tên tags (phân cách bằng dấu phẩy)'];
            if (tagStr) {
                tagStr.toString().split(',').forEach((n: string) => {
                    const trimmed = n.trim();
                    if (trimmed) uniqueTags.add(trimmed);
                });
            }
        });

        const createdItems: string[] = [];

        // Helper: find missing names
        const findMissing = (names: Set<string>, existingList: any[], getName: (item: any) => string) => {
            return Array.from(names).filter(name =>
                !existingList.some(item => {
                    try {
                        const itemName = getName(item);
                        return itemName && itemName.toLowerCase() === name.toLowerCase();
                    } catch {
                        return false;
                    }
                })
            );
        };

        // Helper to normalize entity response - ensure it has { id, name }
        const normalizeEntity = (res: any, fallbackName: string) => {
            const entity = res?.data?.data || res?.data || res;
            if (entity && entity.id && !entity.name) {
                entity.name = fallbackName;
            }
            return entity;
        };

        // 1. Create missing authors
        const missingAuthors = findMissing(uniqueAuthors, listAuthor || [], getAuthorName);
        const newAuthors: any[] = [];
        for (const name of missingAuthors) {
            try {
                const res = await axios.post(`${API_URL.HOST}/authors`, { name });
                newAuthors.push(normalizeEntity(res, name));
                createdItems.push(`Tác giả: ${name}`);
            } catch (e) {
                console.warn(`Không thể tạo tác giả "${name}":`, e);
            }
        }

        // 2. Create missing categories
        const missingCategories = findMissing(uniqueCategories, listCategory || [], (item) => item.name);
        const newCategories: any[] = [];
        for (const name of missingCategories) {
            try {
                const res = await axios.post(`${API_URL.HOST}/category`, { name });
                newCategories.push(normalizeEntity(res, name));
                createdItems.push(`Thể loại: ${name}`);
            } catch (e) {
                console.warn(`Không thể tạo thể loại "${name}":`, e);
            }
        }

        // 3. Create missing publishers
        const missingPublishers = findMissing(uniquePublishers, listPublisher || [], (item) => item.name);
        const newPublishers: any[] = [];
        for (const name of missingPublishers) {
            try {
                const res = await fetch(`${API_URL.HOST}/publishing-houses`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${getToken()}`,
                    },
                    body: JSON.stringify({ name }),
                });
                const data = await res.json();
                newPublishers.push(normalizeEntity(data, name));
                createdItems.push(`Nhà xuất bản: ${name}`);
            } catch (e) {
                console.warn(`Không thể tạo nhà xuất bản "${name}":`, e);
            }
        }

        // 4. Create missing translators
        const missingTranslators = findMissing(uniqueTranslators, lstTranslator || [], getAuthorName);
        const newTranslators: any[] = [];
        for (const name of missingTranslators) {
            try {
                const res = await axios.post(`${API_URL.HOST}/translator`, { name });
                newTranslators.push(normalizeEntity(res, name));
                createdItems.push(`Dịch giả: ${name}`);
            } catch (e) {
                console.warn(`Không thể tạo dịch giả "${name}":`, e);
            }
        }

        // 5. Create missing tags
        const missingTags = findMissing(uniqueTags, lstTags || [], (item) => item.name);
        const newTags: any[] = [];
        for (const name of missingTags) {
            try {
                const tag = await tagsApi.createTag({ name });
                const normalizedTag = tag && tag.id ? tag : { id: tag?.id, name };
                newTags.push(normalizedTag);
                createdItems.push(`Tag: ${name}`);
            } catch (e) {
                console.warn(`Không thể tạo tag "${name}":`, e);
            }
        }

        // Show notification if items were created
        if (createdItems.length > 0) {
            notification.info({
                message: `Đã tự động tạo ${createdItems.length} mục mới`,
                description: createdItems.join(', '),
                placement: 'topRight',
                duration: 5,
            });
        }

        // Return updated lists (existing + newly created)
        return {
            updatedAuthors: [...(listAuthor || []), ...newAuthors],
            updatedCategories: [...(listCategory || []), ...newCategories],
            updatedPublishers: [...(listPublisher || []), ...newPublishers],
            updatedTranslators: [...(lstTranslator || []), ...newTranslators],
            updatedTags: [...(lstTags || []), ...newTags],
        };
    };

    // Excel handling functions
    const downloadExcelTemplate = () => {
        const templateData = [
            {
                'Tên sách': 'Ví dụ: Cẩm Bẩy Người',
                'Mô tả': 'Mô tả chi tiết về cuốn sách...',
                'Số trang': 320,
                'Giá sách vật lý (VNĐ)': 85000,
                'Giá ebook (VNĐ)': 45000,
                'Giá audio (VNĐ)': 60000,
                'Số lượng kho': 100,
                'Mã ISBN': '9786041234567',
                'Kích thước': '14x20cm',
                'Ngày phát hành (YYYY-MM-DD)': '2020-05-15',
                'Ngôn ngữ': 'vietnamese',
                'Tên thể loại (phân cách bằng dấu phẩy)': 'Văn học, Tiểu thuyết, Trinh thám',
                'Tên tác giả (phân cách bằng dấu phẩy)': 'Vũ Trọng Phụng, Nguyễn Nhật Ánh',
                'Tên dịch giả (phân cách bằng dấu phẩy)': 'Nguyễn Văn A',
                'Tên nhà xuất bản': 'NXB Văn Học',
                'Tên tags (phân cách bằng dấu phẩy)': 'văn học, cổ điển, hiện thực'
            }
        ];

        const worksheet = XLSX.utils.json_to_sheet(templateData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Mẫu sách');
        
        // Thêm sheet hướng dẫn
        const instructionData = [
            { 'Trường': 'Tên sách', 'Bắt buộc': 'Có', 'Mô tả': 'Tên của cuốn sách' },
            { 'Trường': 'Mô tả', 'Bắt buộc': 'Có', 'Mô tả': 'Mô tả chi tiết về nội dung sách' },
            { 'Trường': 'Số trang', 'Bắt buộc': 'Không', 'Mô tả': 'Số trang của sách (số nguyên)' },
            { 'Trường': 'Giá sách vật lý (VNĐ)', 'Bắt buộc': 'Có', 'Mô tả': 'Giá tiền của sách giấy (số nguyên)' },
            { 'Trường': 'Giá ebook (VNĐ)', 'Bắt buộc': 'Không', 'Mô tả': 'Giá tiền của ebook (số nguyên)' },
            { 'Trường': 'Giá audio (VNĐ)', 'Bắt buộc': 'Không', 'Mô tả': 'Giá tiền của audiobook (số nguyên)' },
            { 'Trường': 'Số lượng kho', 'Bắt buộc': 'Không', 'Mô tả': 'Số lượng sách trong kho (mặc định: 50)' },
            { 'Trường': 'Mã ISBN', 'Bắt buộc': 'Không', 'Mô tả': 'Mã số tiêu chuẩn quốc tế của sách' },
            { 'Trường': 'Kích thước', 'Bắt buộc': 'Không', 'Mô tả': 'Kích thước sách (ví dụ: 14x20cm)' },
            { 'Trường': 'Ngày phát hành', 'Bắt buộc': 'Không', 'Mô tả': 'Định dạng: YYYY-MM-DD (ví dụ: 2023-12-25)' },
            { 'Trường': 'Ngôn ngữ', 'Bắt buộc': 'Có', 'Mô tả': 'vietnamese, english, french, chinese, japanese' },
            { 'Trường': 'Tên thể loại', 'Bắt buộc': 'Có', 'Mô tả': 'Tên các thể loại, phân cách bằng dấu phẩy (Văn học, Tiểu thuyết)' },
            { 'Trường': 'Tên tác giả', 'Bắt buộc': 'Có', 'Mô tả': 'Tên các tác giả, phân cách bằng dấu phẩy (Vũ Trọng Phụng, Nguyễn Nhật Ánh)' },
            { 'Trường': 'Tên dịch giả', 'Bắt buộc': 'Không', 'Mô tả': 'Tên các dịch giả, phân cách bằng dấu phẩy (Nguyễn Văn A)' },
            { 'Trường': 'Tên nhà xuất bản', 'Bắt buộc': 'Có', 'Mô tả': 'Tên nhà xuất bản (NXB Văn Học)' },
            { 'Trường': 'Tên tags', 'Bắt buộc': 'Không', 'Mô tả': 'Tên các tag, phân cách bằng dấu phẩy (văn học, cổ điển)' }
        ];
        
        const instructionSheet = XLSX.utils.json_to_sheet(instructionData);
        XLSX.utils.book_append_sheet(workbook, instructionSheet, 'Hướng dẫn');
        
        XLSX.writeFile(workbook, 'Mau_them_sach.xlsx');
        
        notification.success({
            message: 'Tải xuống thành công',
            description: 'File mẫu Excel đã được tải xuống',
            placement: 'topRight'
        });
    };

    const handleExcelUpload = (file: any) => {
        setExcelFile(file);
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target?.result as ArrayBuffer);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                
                console.log('Excel data:', jsonData);
                setExcelData(jsonData);
                setIsExcelModalVisible(true);
            } catch (error) {
                console.error('Error reading Excel file:', error);
                notification.error({
                    message: 'Lỗi đọc file Excel',
                    description: 'Không thể đọc file Excel. Vui lòng kiểm tra lại định dạng file.',
                    placement: 'topRight'
                });
            }
        };
        reader.readAsArrayBuffer(file);
        return false; // Prevent upload
    };

    const parseExcelDataToBooks = (data: any[], entityLists?: {
        authors?: any[];
        categories?: any[];
        publishers?: any[];
        translators?: any[];
        tags?: any[];
    }) => {
        // Use provided lists (fresh from ensureEntitiesExist) or fallback to store/local state
        const authorList = entityLists?.authors || listAuthor || [];
        const categoryList = entityLists?.categories || listCategory || [];
        const publisherList = entityLists?.publishers || listPublisher || [];
        const translatorList = entityLists?.translators || lstTranslator || [];
        const tagList = entityLists?.tags || lstTags || [];

        return data.map((row: any, index: number) => {
            const parseNamesToIds = (nameStr: string, dataList: any[], getNameFunc: (item: any) => string) => {
                if (!nameStr) return [];
                const names = nameStr.toString().split(',').map((name: string) => name.trim());
                const ids: number[] = [];
                const notFoundNames: string[] = [];

                names.forEach(name => {
                    const foundItem = dataList.find(item => {
                        try {
                            const itemName = getNameFunc(item);
                            return itemName && itemName.toLowerCase() === name.toLowerCase();
                        } catch {
                            return false;
                        }
                    });
                    if (foundItem) {
                        ids.push(foundItem.id);
                    } else {
                        notFoundNames.push(name);
                    }
                });

                if (notFoundNames.length > 0) {
                    console.warn(`Không tìm thấy: ${notFoundNames.join(', ')} trong dòng ${index + 1}`);
                }

                return ids;
            };

            const categoryIds = parseNamesToIds(
                row['Tên thể loại (phân cách bằng dấu phẩy)'],
                categoryList,
                (item) => item.name
            );

            const authorIds = parseNamesToIds(
                row['Tên tác giả (phân cách bằng dấu phẩy)'],
                authorList,
                (item) => getAuthorName(item)
            );

            const translatorIds = parseNamesToIds(
                row['Tên dịch giả (phân cách bằng dấu phẩy)'],
                translatorList,
                (item) => getAuthorName(item)
            );

            const publisherName = row['Tên nhà xuất bản'];
            let publishing_house_id = null;
            if (publisherName) {
                const foundPublisher = publisherList.find((pub: any) =>
                    pub && pub.name && pub.name.toLowerCase() === publisherName.toLowerCase()
                );
                if (foundPublisher) {
                    publishing_house_id = foundPublisher.id;
                } else {
                    console.warn(`Không tìm thấy nhà xuất bản: ${publisherName} trong dòng ${index + 1}`);
                }
            }

            const parseTagsFromNames = (tagStr: string) => {
                if (!tagStr) return [];
                const tagNames = tagStr.toString().split(',').map((name: string) => name.trim());
                const tagIds: number[] = [];
                const notFoundTags: string[] = [];

                tagNames.forEach(tagName => {
                    const foundTag = tagList.find((tag: any) =>
                        tag && tag.name && tag.name.toLowerCase() === tagName.toLowerCase()
                    );
                    if (foundTag) {
                        tagIds.push(foundTag.id);
                    } else {
                        notFoundTags.push(tagName);
                    }
                });

                if (notFoundTags.length > 0) {
                    console.warn(`Không tìm thấy tags: ${notFoundTags.join(', ')} trong dòng ${index + 1}`);
                }

                return tagIds;
            };

            return {
                id: Date.now() + index,
                name: row['Tên sách'] || '',
                description: row['Mô tả'] || '',
                pageNumber: parseInt(row['Số trang']) || 0,
                pricePaper: parseInt(row['Giá sách vật lý (VNĐ)']) || 0,
                priceEbook: parseInt(row['Giá ebook (VNĐ)']) || 0,
                priceAudio: parseInt(row['Giá audio (VNĐ)']) || 0,
                amount: parseInt(row['Số lượng kho']) || 50,
                ISBN: row['Mã ISBN'] || '',
                size: row['Kích thước'] || '',
                releaseDate: row['Ngày phát hành (YYYY-MM-DD)'] || new Date().toISOString().split('T')[0],
                language: row['Ngôn ngữ'] || 'vietnamese',
                thumbnailUrl: '',
                categoryIds,
                authorIds,
                translatorIds,
                publishing_house_id,
                tagIds: parseTagsFromNames(row['Tên tags (phân cách bằng dấu phẩy)']),
                originalData: {
                    categories: row['Tên thể loại (phân cách bằng dấu phẩy)'] || '',
                    authors: row['Tên tác giả (phân cách bằng dấu phẩy)'] || '',
                    translators: row['Tên dịch giả (phân cách bằng dấu phẩy)'] || '',
                    publisher: row['Tên nhà xuất bản'] || '',
                    tags: row['Tên tags (phân cách bằng dấu phẩy)'] || ''
                }
            };
        });
    };

    const handleImportExcel = async (autoSubmit: boolean = false) => {
        setIsProcessingExcel(true);
        try {
            // Step 1: Auto-create any missing authors, categories, publishers, translators, tags
            const updatedLists = await ensureEntitiesExist(excelData);

            // Step 2: Parse Excel data with fresh (updated) lists
            const parsedBooks = parseExcelDataToBooks(excelData, {
                authors: updatedLists.updatedAuthors,
                categories: updatedLists.updatedCategories,
                publishers: updatedLists.updatedPublishers,
                translators: updatedLists.updatedTranslators,
                tags: updatedLists.updatedTags,
            });

            console.log('Parsed books from Excel:', parsedBooks);

            // Validate
            let validBooks = 0;
            let errorCount = 0;
            const validationErrors: string[] = [];

            parsedBooks.forEach((book, index) => {
                const rowNumber = index + 1;
                let hasError = false;

                if (!book.name) {
                    validationErrors.push(`Dòng ${rowNumber}: Thiếu tên sách`);
                    hasError = true;
                }
                if (!book.description) {
                    validationErrors.push(`Dòng ${rowNumber}: Thiếu mô tả sách`);
                    hasError = true;
                }
                if (!book.pricePaper) {
                    validationErrors.push(`Dòng ${rowNumber}: Thiếu giá sách vật lý`);
                    hasError = true;
                }
                if (!book.categoryIds || book.categoryIds.length === 0) {
                    validationErrors.push(`Dòng ${rowNumber}: Không tìm thấy thể loại hợp lệ`);
                    hasError = true;
                }
                if (!book.authorIds || book.authorIds.length === 0) {
                    validationErrors.push(`Dòng ${rowNumber}: Không tìm thấy tác giả hợp lệ`);
                    hasError = true;
                }
                if (!book.publishing_house_id) {
                    validationErrors.push(`Dòng ${rowNumber}: Không tìm thấy nhà xuất bản hợp lệ`);
                    hasError = true;
                }

                if (hasError) {
                    errorCount++;
                } else {
                    validBooks++;
                }
            });

            if (validationErrors.length > 0) {
                console.warn('Validation errors:', validationErrors);
                const errorMessage = validationErrors.slice(0, 5).join('\n') +
                    (validationErrors.length > 5 ? `\n... và ${validationErrors.length - 5} lỗi khác` : '');

                notification.warning({
                    message: `Có ${errorCount} dòng lỗi, ${validBooks} dòng hợp lệ`,
                    description: errorMessage,
                    placement: 'topRight',
                    duration: 10
                });
            }

            setBookRows(parsedBooks);
            setIsExcelModalVisible(false);
            setExcelData([]);
            setExcelFile(null);

            notification.success({
                message: 'Import hoàn tất',
                description: `Đã import ${parsedBooks.length} sách từ file Excel (${validBooks} hợp lệ, ${errorCount} có lỗi)`,
                placement: 'topRight'
            });

            if (autoSubmit && validBooks > 0) {
                setTimeout(() => {
                    onAddMultipleBooks();
                }, 1000);
            }
        } catch (error) {
            console.error('Error importing Excel:', error);
            notification.error({
                message: 'Lỗi khi import file Excel',
                description: 'Có lỗi xảy ra trong quá trình import. Vui lòng thử lại.',
                placement: 'topRight'
            });
        } finally {
            setIsProcessingExcel(false);
        }
    };

    // Multiple books functions
    const addBookRow = () => {
        const newBook = {
            id: Date.now(),
            name: '',
            description: '',
            pageNumber: 0,
            pricePaper: 0,
            priceEbook: 0,
            priceAudio: 0,
            amount: 50,
            ISBN: '',
            size: '',
            releaseDate: new Date().toISOString().split('T')[0],
            language: 'vietnamese',
            thumbnailUrl: '',
            categoryIds: [],
            authorIds: [],
            translatorIds: [],
            publishing_house_id: null,
            tagIds: []
        };
        setBookRows([...bookRows, newBook]);
    };

    const removeBookRow = (id: number) => {
        if (bookRows.length > 1) {
            setBookRows(bookRows.filter(book => book.id !== id));
        }
    };

    const updateBookRow = (id: number, field: string, value: any) => {
        setBookRows(bookRows.map(book => 
            book.id === id ? { ...book, [field]: value } : book
        ));
    };

    const onAddMultipleBooks = async () => {
        console.log('onAddMultipleBooks called, isSubmitting:', isSubmitting);
        console.log('Current bookRows:', bookRows);
        
        if (isSubmitting) return;
        
        const validBooks = bookRows.filter(book => 
            book.name && 
            book.categoryIds.length > 0 && 
            book.authorIds.length > 0 && 
            book.publishing_house_id &&
            book.language &&
            book.description
        );

        console.log('Valid books after filtering:', validBooks);
        console.log('Total bookRows:', bookRows.length, 'Valid books:', validBooks.length);

        if (validBooks.length === 0) {
            console.log('No valid books found');
            notification.error({
                message: 'Lỗi',
                description: 'Không có sách nào hợp lệ để thêm. Vui lòng kiểm tra các trường bắt buộc.',
                placement: 'topRight'
            });
            return;
        }

        setIsSubmitting(true);
        
        let successCount = 0;
        let errorCount = 0;

        for (let i = 0; i < validBooks.length; i++) {
            const book = validBooks[i];
            
            console.log(`Processing book ${i + 1}/${validBooks.length}:`, book.name);
            
            try {
                const bodyRequest = {
                    name: book.name,
                    thumbnailUrl: book.thumbnailUrl || '',
                    ISBN: book.ISBN || '',
                    description: book.description || "",
                    country: "Vietnam",
                    language: book.language || "vietnamese",
                    pageNumber: book.pageNumber ? Number(book.pageNumber) : 0,
                    ebookUrl: 'string',
                    previewEbookUrl: 'string',
                    previewAudiobookUrl: '',
                    pricePaper: book.pricePaper ? Number(book.pricePaper) : 0,
                    priceEbook: book.priceEbook ? Number(book.priceEbook) : 0,
                    priceAudio: book.priceAudio ? Number(book.priceAudio) : 0,
                    amount: book.amount || 50,
                    releaseDate: book.releaseDate ? new Date(book.releaseDate).toISOString() : new Date().toISOString(),
                    generateId: '',
                    publishing_house_id: book.publishing_house_id ? Number(book.publishing_house_id) : null,
                    authorIds: book.authorIds && book.authorIds.length > 0 ? book.authorIds.map((id: any) => Number(id)) : [],
                    translatorIds: book.translatorIds && book.translatorIds.length > 0 ? book.translatorIds.map((id: any) => Number(id)) : [],
                    categoryIds: book.categoryIds && book.categoryIds.length > 0 ? book.categoryIds.map((id: any) => Number(id)) : [],
                    size: book.size || "",
                    sync: true
                };

                console.log('Sending API request with body:', bodyRequest);
                const response = await BookApi.addBook(bodyRequest).toPromise();
                console.log('API response:', response);

                if (response && response.data && response.data.id && book.tagIds && book.tagIds.length > 0) {
                    try {
                        await BookApi.assignTags(response.data.id, book.tagIds).toPromise();
                    } catch (tagError) {
                        console.error('Error assigning tags:', tagError);
                    }
                }

                successCount++;
            } catch (error) {
                console.error(`Error adding book ${book.name}:`, error);
                errorCount++;
            }
        }

        setIsSubmitting(false);

        if (successCount > 0) {
            notification.success({
                message: 'Hoàn thành',
                description: `Đã thêm thành công ${successCount} sách${errorCount > 0 ? `, ${errorCount} sách bị lỗi` : ''}`,
                placement: 'topRight'
            });
            
            // Reset book rows and refresh list
            setBookRows([{
                id: Date.now(),
                name: '',
                description: '',
                pageNumber: 0,
                pricePaper: 0,
                priceEbook: 0,
                priceAudio: 0,
                amount: 50,
                ISBN: '',
                size: '',
                releaseDate: new Date().toISOString().split('T')[0],
                language: 'vietnamese',
                thumbnailUrl: '',
                categoryIds: [],
                authorIds: [],
                translatorIds: [],
                publishing_house_id: null,
                tagIds: []
            }]);
            dispatch(getBookRequest({ limit: 10, page: 1 }));
            navigate("/management/book");
        } else {
            notification.error({
                message: 'Lỗi',
                description: 'Không thể thêm sách nào. Vui lòng kiểm tra lại thông tin.',
                placement: 'topRight'
            });
        }
    };

    return (
        <div className="main-upload">
            <div className="upload-area">
                <div className="title-upload-book">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2>
                            <BookOutlined style={{ color: 'var(--primary-color)', fontSize: '16px' }} />
                            Thêm sách mới
                        </h2>
                        <div style={{ display: 'flex', gap: '12px' }}>
                            <Button
                                type="default"
                                icon={<DownloadOutlined />}
                                onClick={downloadExcelTemplate}
                                size="small"
                            >
                                Tải file mẫu Excel
                            </Button>
                            <Upload
                                accept=".xlsx,.xls"
                                beforeUpload={handleExcelUpload}
                                showUploadList={false}
                                multiple={false}
                            >
                                <Button
                                    type="primary"
                                    icon={<FileExcelOutlined />}
                                    size="small"
                                >
                                    Thêm sách bằng Excel
                                </Button>
                            </Upload>
                        </div>
                    </div>
                </div>

                {/* Multiple Books List */}
                <div className="multiple-books-container" style={{ marginBottom: '20px' }}>
                    {bookRows.map((book, index) => (
                        <Card 
                            key={book.id} 
                            title={
                                <Row justify="space-between" align="middle">
                                    <Col>
                                        <span>
                                            <BookOutlined style={{ marginRight: '6px', color: 'var(--primary-color)' }} />
                                            Danh sách sách ({index + 1})
                                        </span>
                                    </Col>
                                    <Col>
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                            <Button 
                                                type="primary" 
                                                size="small"
                                                icon={<PlusOutlined />}
                                                onClick={addBookRow}
                                            >
                                                Thêm sách
                                            </Button>
                                            {bookRows.length > 1 && (
                                                <Button 
                                                    danger
                                                    size="small"
                                                    icon={<DeleteOutlined />}
                                                    onClick={() => removeBookRow(book.id)}
                                                >
                                                    Xóa
                                                </Button>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            }
                            style={{ marginBottom: '16px' }}
                            size="small"
                        >
                            <Form layout="vertical">
                    <Row gutter={12}>
                        <Col span={10}>
                            <Form.Item
                                label={
                                    <span>
                                        <FileTextOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Tên sách
                                    </span>
                                }
                                rules={[{ required: true, message: 'Vui lòng nhập tên sách' }]}
                            >
                                <Input
                                    value={book.name}
                                    placeholder="Nhập tên sách"
                                    onChange={(e) => updateBookRow(book.id, 'name', e.target.value)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                label={
                                    <span>
                                        <UserOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Tác giả
                                    </span>
                                }
                                rules={[{ required: true, message: 'Vui lòng chọn tác giả' }]}
                            >
                                <Select
                                    mode="multiple"
                                    showSearch
                                    value={book.authorIds}
                                    placeholder="Chọn tác giả"
                                    onChange={(value) => updateBookRow(book.id, 'authorIds', value)}
                                    filterOption={(input, option) =>
                                        (option?.children as unknown as string)?.toLowerCase().includes(input.toLowerCase())
                                    }
                                    dropdownRender={(menu) => (
                                        <>
                                            {menu}
                                            <div style={{ padding: '8px', borderTop: '1px solid #f0f0f0' }}>
                                                <Button
                                                    type="link"
                                                    onClick={() => setIsModalAuthorOpen(true)}
                                                    style={{ width: '100%', textAlign: 'left' }}
                                                    icon={<PlusOutlined />}
                                                >
                                                    Thêm tác giả mới
                                                </Button>
                                            </div>
                                        </>
                                    )}
                                >
                                    {(listAuthor && listAuthor.length > 0) && listAuthor.map((index) => (
                                        <Select.Option key={index.id} value={index.id}>{getAuthorName(index)}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                label={
                                    <span>
                                        <BankOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Nhà xuất bản
                                    </span>
                                }
                                rules={[{ required: true, message: 'Vui lòng chọn nhà xuất bản' }]}
                            >
                                <Select
                                    showSearch={true}
                                    value={book.publishing_house_id}
                                    placeholder="Chọn NXB"
                                    onChange={(value) => updateBookRow(book.id, 'publishing_house_id', value)}
                                    filterOption={(input, option) =>
                                        (option?.children as unknown as string)?.toLowerCase().includes(input.toLowerCase())
                                    }
                                    notFoundContent={
                                        <Button type="link" onClick={() => {
                                            setIsModalPublisherOpen(true)
                                        }}>
                                            <PlusOutlined /> Thêm nhà xuất bản
                                        </Button>
                                    }
                                >
                                    {(listPublisher && listPublisher.length > 0) && listPublisher.map((index) => (
                                        <Select.Option key={index.id} value={index.id}>{index.name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={12}>
                        <Col span={6}>
                            <Form.Item
                                label={
                                    <span>
                                        <TagOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Thể loại
                                    </span>
                                }
                                rules={[{ required: true, message: 'Vui lòng chọn thể loại' }]}
                            >
                                <Select
                                    mode="multiple"
                                    showSearch
                                    value={book.categoryIds}
                                    placeholder="Chọn thể loại"
                                    onChange={(value) => updateBookRow(book.id, 'categoryIds', value)}
                                    filterOption={(input, option) =>
                                        (option?.children as unknown as string)?.toLowerCase().includes(input.toLowerCase())
                                    }
                                    notFoundContent={
                                        <Button type="link" onClick={() => {
                                            setIsModalCriteriaOpen(true)
                                        }}>
                                            <PlusOutlined /> Thêm thể loại
                                        </Button>
                                    }
                                >
                                    {(listCategory && listCategory.length > 0) && listCategory.map((index: any) => (
                                        <Select.Option key={index.id} value={index.id}>{index.name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={5}>
                            <Form.Item
                                label={
                                    <span>
                                        <GlobalOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Ngôn ngữ
                                    </span>
                                }
                                rules={[{ required: true, message: 'Vui lòng chọn ngôn ngữ' }]}
                            >
                                <Select
                                    value={book.language}
                                    placeholder="Chọn ngôn ngữ"
                                    onChange={(value) => updateBookRow(book.id, 'language', value)}
                                >
                                    <Select.Option value="vietnamese">Tiếng Việt</Select.Option>
                                    <Select.Option value="english">Tiếng Anh</Select.Option>
                                    <Select.Option value="french">Tiếng Pháp</Select.Option>
                                    <Select.Option value="chinese">Tiếng Trung</Select.Option>
                                    <Select.Option value="japanese">Tiếng Nhật</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                label={
                                    <span>
                                        <FileTextOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Số trang
                                    </span>
                                }
                                rules={[{ required: true, message: 'Vui lòng nhập số trang sách' }]}
                            >
                                <Input
                                    value={book.pageNumber}
                                    style={{ width: '100%' }}
                                    onChange={(e) => updateBookRow(book.id, 'pageNumber', e.target.value)}
                                    placeholder="Số trang"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                label={
                                    <span>
                                        <CalendarOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Ngày phát hành
                                    </span>
                                }
                                rules={[{ required: true, message: 'Vui lòng nhập ngày phát hành' }]}
                            >
                                <DatePicker
                                    value={book.releaseDate ? moment(book.releaseDate) : null}
                                    style={{ width: '100%' }}
                                    placeholder="Ngày"
                                    onChange={(date, dateString) => updateBookRow(book.id, 'releaseDate', dateString)}
                                    format="YYYY-MM-DD"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={5}>
                            <Form.Item
                                label={
                                    <span>
                                        <FileTextOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Kích thước
                                    </span>
                                }
                            >
                                <Input
                                    value={book.size}
                                    placeholder="VD: 14x20cm"
                                    onChange={(e) => updateBookRow(book.id, 'size', e.target.value)}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={12}>
                        <Col span={5}>
                            <Form.Item
                                label={
                                    <span>
                                        <DollarOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Giá sách vật lý
                                    </span>
                                }
                                rules={[{ required: true, message: 'Vui lòng nhập giá sách' }]}
                            >
                                <Input
                                    value={book.pricePaper}
                                    style={{ width: '100%' }}
                                    placeholder="VND"
                                    onChange={(e) => updateBookRow(book.id, 'pricePaper', e.target.value)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={5}>
                            <Form.Item
                                label={
                                    <span>
                                        <DollarOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Giá ebook
                                    </span>
                                }
                            >
                                <Input
                                    value={book.priceEbook}
                                    style={{ width: '100%' }}
                                    placeholder="VND"
                                    onChange={(e) => updateBookRow(book.id, 'priceEbook', e.target.value)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={5}>
                            <Form.Item
                                label={
                                    <span>
                                        <DollarOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Giá audio
                                    </span>
                                }
                            >
                                <Input
                                    value={book.priceAudio}
                                    style={{ width: '100%' }}
                                    placeholder="VND"
                                    onChange={(e) => updateBookRow(book.id, 'priceAudio', e.target.value)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                label={
                                    <span>
                                        <ProfileOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Số lượng kho
                                    </span>
                                }
                                rules={[{ required: true, message: 'Vui lòng nhập số lượng' }]}
                            >
                                <InputNumber
                                    value={book.amount}
                                    style={{ width: '100%' }}
                                    min={0}
                                    placeholder="50"
                                    onChange={(value) => updateBookRow(book.id, 'amount', value || 50)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={5}>
                            <Form.Item
                                label={
                                    <span>
                                        <BookOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Mã ISBN
                                    </span>
                                }
                            >
                                <Input
                                    value={book.ISBN}
                                    placeholder="Mã ISBN (tùy chọn)"
                                    onChange={(e) => updateBookRow(book.id, 'ISBN', e.target.value)}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={12}>
                        <Col span={8}>
                            <Form.Item
                                label={
                                    <span>
                                        <TagOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Tags
                                    </span>
                                }
                            >
                                <TagsSelector
                                    value={book.tagIds}
                                    onChange={(value) => updateBookRow(book.id, 'tagIds', value)}
                                    placeholder="Chọn tags cho sách"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                label={
                                    <span>
                                        <UserOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Dịch giả
                                    </span>
                                }
                            >
                                <Select
                                    mode="multiple"
                                    showSearch
                                    value={book.translatorIds}
                                    placeholder="Chọn dịch giả"
                                    onChange={(value) => updateBookRow(book.id, 'translatorIds', value)}
                                    filterOption={(input, option) =>
                                        (option?.children as unknown as string)?.toLowerCase().includes(input.toLowerCase())
                                    }
                                    dropdownRender={(menu) => (
                                        <>
                                            {menu}
                                            <div style={{ padding: '8px', borderTop: '1px solid #f0f0f0' }}>
                                                <Button
                                                    type="link"
                                                    onClick={() => setIsModalTranslatorOpen(true)}
                                                    style={{ width: '100%', textAlign: 'left' }}
                                                    icon={<PlusOutlined />}
                                                >
                                                    Thêm dịch giả
                                                </Button>
                                            </div>
                                        </>
                                    )}
                                >
                                    {(lstTranslator && lstTranslator.length > 0) && lstTranslator.map((index: any) => (
                                        <Select.Option key={index.id} value={index.id}>{getAuthorName(index)}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={10}>
                            <Form.Item
                                label={
                                    <span>
                                        <FileTextOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                        Mô tả sách
                                    </span>
                                }
                                rules={[{ required: true, message: 'Vui lòng nhập mô tả sách' }]}
                            >
                                <TextArea
                                    value={book.description}
                                    placeholder="Nhập mô tả sách"
                                    onChange={(e) => updateBookRow(book.id, 'description', e.target.value)}
                                    className="form-textarea"
                                />
                            </Form.Item>
                        </Col>
                    </Row>



                            </Form>
                        </Card>
                    ))}
                    
                    {/* Submit Button */}
                    <div className="multiple-books-submit">
                        <Button
                            type="primary"
                            size="large"
                            icon={<PlusOutlined />}
                            onClick={onAddMultipleBooks}
                            loading={isSubmitting}
                            disabled={bookRows.length === 0}
                        >
                            {isSubmitting ? 'Đang thêm...' : `Thêm tất cả (${bookRows.length} sách)`}
                        </Button>
                    </div>
                </div>
            </div >
            {openModalCategory && (
                <Modal
                    open={openModalCategory}
                    onOk={() => setOpenModalCategory(false)}
                    closable={true}
                    onCancel={onCancelAddCategory}
                    title={"Thêm Thể Loại"}
                    className="modal-add-category"
                    footer={false}
                    width={500}>
                    <>
                        <Form
                            onFinish={onAddCategory}
                        >
                            <Form.Item className="title" label="Tên Thể Loại" >
                                <Input style={{ width: "70%" }} onChange={handleCategoryChange} />
                            </Form.Item>
                            <motion.div>
                                {
                                    newCategory ? (
                                        <Button type="primary" htmlType="submit">
                                            Thêm
                                        </Button>
                                    ) : (
                                        <Button type="primary" htmlType="submit" disabled>
                                            Thêm
                                        </Button>
                                    )

                                }
                            </motion.div>
                        </Form>
                    </>
                </Modal>
            )}

            {
                openModalPublisher && (
                    <Modal
                        open={openModalPublisher}
                        onOk={() => setOpenModalPublisher(false)}
                        closable={true}
                        onCancel={onCancelAddPublisher}
                        title={"Thêm Nhà Xuất Bản"}
                        className="modal-add-publisher"
                        footer={false}
                        width={500}>
                        <>
                            <Form
                                onFinish={onAddPublisher}
                            >
                                <Form.Item className="title" label="Tên nhà xuất bản" >
                                    <Input style={{ width: "70%" }} onChange={handlePublisherChange} />
                                </Form.Item>
                                <motion.div>
                                    {
                                        newPublisher ? (
                                            <Button type="primary" htmlType="submit">
                                                Thêm
                                            </Button>
                                        ) : (
                                            <Button type="primary" htmlType="submit" disabled>
                                                Thêm
                                            </Button>
                                        )

                                    }
                                </motion.div>
                            </Form>
                        </>
                    </Modal>
                )
            }
            <Modal
                title={
                    <span>
                        <TagOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '14px' }} />
                        Thêm thể loại mới
                    </span>
                }
                visible={isModalCriteriaOpen}
                onOk={() => {
                    confirmCloseModal({
                        hasChanges: hasChangesCriteria,
                        onConfirm: () => {
                            setIsModalCriteriaOpen(false);
                            formAddCriteria.resetFields();
                            setHasChangesCriteria(false);
                        },
                        title: 'Xác nhận đóng',
                        content: 'Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn đóng modal thêm thể loại?'
                    });
                }}
                onCancel={() => {
                    confirmCloseModal({
                        hasChanges: hasChangesCriteria,
                        onConfirm: () => {
                            setIsModalCriteriaOpen(false);
                            formAddCriteria.resetFields();
                            setHasChangesCriteria(false);
                        },
                        title: 'Xác nhận đóng',
                        content: 'Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn đóng modal thêm thể loại?'
                    });
                }}
                footer={false}
                maskClosable={true}
                className="modal-add-category"
                width={400}
            >

                <Form form={formAddCriteria} onFinish={handleAddCriteria}>
                    <Form.Item
                        label={
                            <span>
                                <TagOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                Tên thể loại
                            </span>
                        }
                        name='criteria'
                    >
                        <Input placeholder="Tên thể loại mới" />
                    </Form.Item>

                    <Form.Item style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "var(--spacing-4)"
                    }}>
                        <Button type="primary" htmlType="submit" icon={<PlusOutlined />}>
                            Thêm thể loại
                        </Button>
                    </Form.Item>

                </Form>
            </Modal>

            <Modal
                title={
                    <span>
                        <UserOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '14px' }} />
                        Thêm tác giả mới
                    </span>
                }
                visible={isModalAuthorOpen}
                onOk={() => {
                    confirmCloseModal({
                        hasChanges: hasChangesAuthor,
                        onConfirm: () => {
                            setIsModalAuthorOpen(false);
                            formAddAuthor.resetFields();
                            setHasChangesAuthor(false);
                        },
                        title: 'Xác nhận đóng',
                        content: 'Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn đóng modal thêm tác giả?'
                    });
                }}
                onCancel={() => {
                    confirmCloseModal({
                        hasChanges: hasChangesAuthor,
                        onConfirm: () => {
                            setIsModalAuthorOpen(false);
                            formAddAuthor.resetFields();
                            setHasChangesAuthor(false);
                        },
                        title: 'Xác nhận đóng',
                        content: 'Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn đóng modal thêm tác giả?'
                    });
                }}
                footer={false}
                maskClosable={true}
                className="modal-add-author"
                width={400}
            >

                <Form form={formAddAuthor} onFinish={handleAddAuthor}>
                    <Form.Item
                        label={
                            <span>
                                <UserOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                Tên tác giả
                            </span>
                        }
                        name='name'
                        rules={[{ required: true, message: 'Vui lòng nhập tên tác giả' }]}
                    >
                        <Input placeholder="Nhập tên đầy đủ của tác giả" />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span>
                                <FileTextOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                Mô tả tác giả
                            </span>
                        }
                        name='description'
                    >
                        <TextArea
                            placeholder="Nhập mô tả về tác giả (tùy chọn)"
                            rows={4}
                            className="form-textarea"
                        />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span>
                                <CalendarOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                Năm sinh
                            </span>
                        }
                        name='birthYear'
                    >
                        <Input
                            placeholder="Nhập năm sinh (tùy chọn)"
                            type="number"
                            min={1800}
                            max={new Date().getFullYear()}
                        />
                    </Form.Item>

                    <Form.Item style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "var(--spacing-4)"
                    }}>
                        <Button type="primary" htmlType="submit" icon={<PlusOutlined />}>
                            Thêm tác giả
                        </Button>
                    </Form.Item>

                </Form>
            </Modal>

            <Modal
                title={
                    <span>
                        <UserOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '14px' }} />
                        Thêm dịch giả mới
                    </span>
                }
                visible={isModalTranslatorOpen}
                onOk={() => {
                    confirmCloseModal({
                        hasChanges: hasChangesTranslator,
                        onConfirm: () => {
                            setIsModalTranslatorOpen(false);
                            formAddTranslator.resetFields();
                            setHasChangesTranslator(false);
                        },
                        title: 'Xác nhận đóng',
                        content: 'Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn đóng modal thêm dịch giả?'
                    });
                }}
                onCancel={() => {
                    confirmCloseModal({
                        hasChanges: hasChangesTranslator,
                        onConfirm: () => {
                            setIsModalTranslatorOpen(false);
                            formAddTranslator.resetFields();
                            setHasChangesTranslator(false);
                        },
                        title: 'Xác nhận đóng',
                        content: 'Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn đóng modal thêm dịch giả?'
                    });
                }}
                footer={false}
                maskClosable={true}
                className="modal-add-translator"
                width={400}
            >
                <Form form={formAddTranslator} onFinish={handleAddTranslator}>
                    <Form.Item
                        label={
                            <span>
                                <UserOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                Tên dịch giả
                            </span>
                        }
                        name='name'
                        rules={[{ required: true, message: 'Vui lòng nhập tên dịch giả' }]}
                    >
                        <Input placeholder="Nhập tên đầy đủ của dịch giả" />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span>
                                <FileTextOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                Mô tả dịch giả
                            </span>
                        }
                        name='description'
                    >
                        <TextArea
                            placeholder="Nhập mô tả về dịch giả (tùy chọn)"
                            rows={4}
                            className="form-textarea"
                        />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span>
                                <CalendarOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                Năm sinh
                            </span>
                        }
                        name='birthYear'
                    >
                        <Input
                            placeholder="Nhập năm sinh (tùy chọn)"
                            type="number"
                            min={1800}
                            max={new Date().getFullYear()}
                        />
                    </Form.Item>

                    <Form.Item style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "var(--spacing-4)"
                    }}>
                        <Button type="primary" htmlType="submit" icon={<PlusOutlined />}>
                            Thêm dịch giả
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title={
                    <span>
                        <BankOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '14px' }} />
                        Thêm nhà xuất bản mới
                    </span>
                }
                visible={isModalPublisherOpen}
                onOk={() => {
                    confirmCloseModal({
                        hasChanges: hasChangesPublisher,
                        onConfirm: () => {
                            setIsModalPublisherOpen(false);
                            formAddPublisher.resetFields();
                            setHasChangesPublisher(false);
                        },
                        title: 'Xác nhận đóng',
                        content: 'Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn đóng modal thêm nhà xuất bản?'
                    });
                }}
                onCancel={() => {
                    confirmCloseModal({
                        hasChanges: hasChangesPublisher,
                        onConfirm: () => {
                            setIsModalPublisherOpen(false);
                            formAddPublisher.resetFields();
                            setHasChangesPublisher(false);
                        },
                        title: 'Xác nhận đóng',
                        content: 'Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn đóng modal thêm nhà xuất bản?'
                    });
                }}
                footer={false}
                maskClosable={true}
                className="modal-add-publisher"
                width={400}
            >

                <Form form={formAddPublisher} onFinish={handleAddPublisher}>
                    <Form.Item
                        label={
                            <span>
                                <BankOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '12px' }} />
                                Tên nhà xuất bản
                            </span>
                        }
                        name='publisher'
                    >
                        <Input placeholder="Tên nhà xuất bản mới" />
                    </Form.Item>

                    <Form.Item style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "var(--spacing-4)"
                    }}>
                        <Button type="primary" htmlType="submit" icon={<PlusOutlined />}>
                            Thêm nhà xuất bản
                        </Button>
                    </Form.Item>

                </Form>

            </Modal>

            {/* Excel Preview Modal */}
            <Modal
                title={
                    <span>
                        <FileExcelOutlined style={{ marginRight: '6px', color: 'var(--primary-color)', fontSize: '14px' }} />
                        Xem trước dữ liệu Excel
                    </span>
                }
                visible={isExcelModalVisible}
                onCancel={() => {
                    setIsExcelModalVisible(false);
                    setExcelData([]);
                    setExcelFile(null);
                }}
                footer={[
                    <Button key="cancel" onClick={() => {
                        setIsExcelModalVisible(false);
                        setExcelData([]);
                        setExcelFile(null);
                    }}>
                        Hủy
                    </Button>,
                    <Button 
                        key="import" 
                        onClick={() => handleImportExcel(false)}
                        disabled={excelData.length === 0}
                        loading={isProcessingExcel}
                    >
                        Import để xem trước
                    </Button>,
                    <Button 
                        key="import-submit" 
                        type="primary" 
                        onClick={() => handleImportExcel(true)}
                        disabled={excelData.length === 0}
                        loading={isProcessingExcel}
                    >
                        Import & Thêm ngay ({excelData.length} sách)
                    </Button>
                ]}
                width={1200}
                className="excel-preview-modal"
            >
                {excelData.length > 0 ? (
                    <div>
                        <div style={{ marginBottom: '16px', padding: '12px', background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: '6px' }}>
                            <p style={{ margin: 0, color: '#52c41a', fontWeight: '500' }}>
                                ✓ Đã tìm thấy {excelData.length} dòng dữ liệu trong file Excel
                            </p>
                            <p style={{ margin: '4px 0 0 0', color: '#666', fontSize: '13px' }}>
                                Xem trước dữ liệu bên dưới và nhấn "Import" để thêm vào danh sách sách
                            </p>
                        </div>
                        
                        <Table
                            dataSource={excelData.map((item: any, index: number) => ({ ...item, key: index }))}
                            columns={[
                                {
                                    title: 'STT',
                                    width: 60,
                                    render: (_, __, index) => index + 1
                                },
                                {
                                    title: 'Tên sách',
                                    dataIndex: 'Tên sách',
                                    key: 'name',
                                    width: 200,
                                    ellipsis: true
                                },
                                {
                                    title: 'Mô tả',
                                    dataIndex: 'Mô tả',
                                    key: 'description',
                                    width: 150,
                                    ellipsis: true
                                },
                                {
                                    title: 'Giá VL',
                                    dataIndex: 'Giá sách vật lý (VNĐ)',
                                    key: 'pricePaper',
                                    width: 80,
                                    render: (value: any) => value ? `${value.toLocaleString()}đ` : '-'
                                },
                                {
                                    title: 'Thể loại',
                                    dataIndex: 'Tên thể loại (phân cách bằng dấu phẩy)',
                                    key: 'categories',
                                    width: 150,
                                    ellipsis: true
                                },
                                {
                                    title: 'Tác giả',
                                    dataIndex: 'Tên tác giả (phân cách bằng dấu phẩy)',
                                    key: 'authors',
                                    width: 150,
                                    ellipsis: true
                                },
                                {
                                    title: 'Nhà xuất bản',
                                    dataIndex: 'Tên nhà xuất bản',
                                    key: 'publisher',
                                    width: 120,
                                    ellipsis: true
                                },
                                {
                                    title: 'Ngôn ngữ',
                                    dataIndex: 'Ngôn ngữ',
                                    key: 'language',
                                    width: 100
                                }
                            ]}
                            scroll={{ x: 800, y: 400 }}
                            pagination={false}
                            size="small"
                        />
                        
                        <div style={{ marginTop: '16px', padding: '12px', background: '#fff7e6', border: '1px solid #ffd666', borderRadius: '6px' }}>
                            <p style={{ margin: 0, color: '#d48806', fontWeight: '500' }}>
                                ⚠️ Lưu ý quan trọng:
                            </p>
                            <ul style={{ margin: '4px 0 0 0', color: '#666', fontSize: '13px', paddingLeft: '16px' }}>
                                <li>Đảm bảo các tên thể loại, tác giả, nhà xuất bản chính xác và tồn tại trong hệ thống</li>
                                <li>Tên không phân biệt hoa thường, nhưng phải chính xác về chính tả</li>
                                <li>Ngôn ngữ phải là: vietnamese, english, french, chinese, japanese</li>
                                <li>Ngày phát hành phải theo định dạng: YYYY-MM-DD</li>
                                <li>Các trường bắt buộc: Tên sách, Mô tả, Giá sách vật lý, Thể loại, Tác giả, Nhà xuất bản, Ngôn ngữ</li>
                                <li>Nếu có tên không tìm thấy, sách đó sẽ bị báo lỗi khi import</li>
                            </ul>
                        </div>
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <FileExcelOutlined style={{ fontSize: '48px', color: '#d9d9d9' }} />
                        <p style={{ color: '#999', marginTop: '16px' }}>Không có dữ liệu để hiển thị</p>
                    </div>
                )}
            </Modal>

        </div >
    );
};

export default UploadBook;
